var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.33 83.1808C92.7196 99.1491 75.2339 109.843 55.2915 109.843C33.2537 109.843 14.2507 96.9092 5.50781 78.1229C8.75929 75.7385 18.0079 71.5477 32.4589 74.3657C38.8896 75.6663 51.173 79.0623 60.9274 83.5421C69.309 87.3716 76.679 89.2502 82.7484 89.0334C88.4566 88.8889 95.8988 86.7935 102.33 83.1808Z",
    fill: "#0062AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2205 0.0865479C85.5676 0.0865479 110.134 24.6532 110.134 54.9281C110.134 63.0207 108.4 70.6797 105.293 77.6162C98.8625 81.2289 90.5531 84.1914 83.1109 84.4081C76.6802 84.6249 68.6599 82.674 59.628 78.5555C49.0788 73.7144 35.9284 70.1016 28.9919 68.6565C16.1305 65.9831 4.5697 67.645 2.54656 69.8126L2.4743 70.0294C1.10146 65.1883 0.378906 60.2027 0.378906 54.9281C0.378906 24.6532 24.9456 0.0865479 55.2205 0.0865479Z",
    fill: "#00BDEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1514 32.5292C62.3018 22.558 72.2007 23.3528 85.3512 30.5783C72.273 23.7864 59.2671 27.5436 50.0907 36.431C37.8074 32.9628 24.657 35.7084 16.2754 47.8473C24.5847 35.2749 32.894 29.928 49.1514 32.5292Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBg);
export default __webpack_public_path__ + "static/media/success-bg.7ce41995dacd70d621b3b4347c523a4f.svg";
export { ForwardRef as ReactComponent };